<template>
    <div class="container-main">
        <div class="banner-box">
            <div class="container-contact center">
                <div class="left-section-contact">
                    <div class="a-powerful-tool-you-mobile">
                        Reach out to us
                    </div>
                    <img class="working" src="../assets/image/image-63.png" />
                </div>
                <div class="right-section-contact">
                    <div class="a-powerful-tool-you">Reach out to us</div>
                    <div class="contact-form">
                        <div class="fullname">
                            <div class="form-element-contact f-name">
                                <label :class="{ 'active': isFocused['fname'] }" for="fname">First
                                    Name :</label>
                                <input type="text" v-model="fname" id="fname" name="fname"
                                    @focus="handleInputFocus('fname')" @blur="handleInputBlur('fname')" required />
                            </div>

                            <div class="form-element-contact l-name">
                                <label :class="{ 'active': isFocused['lname'] }" for="lname">Last
                                    Name :</label>
                                <input type="text" v-model="lname" id="lname" name="lname"
                                    @focus="handleInputFocus('lname')" @blur="handleInputBlur('lname')" required />
                            </div>
                        </div>

                        <div class="form-element-contact">
                            <label :class="{ 'active': isFocused['phone'] }" for="phone">Telephone Number <span style="color: red;">*</span> :</label>
                            <input type="text" v-model="phone" id="phone" name="phone" @focus="handleInputFocus('phone')" @blur="handleInputBlur('phone')"
                            @input="validatePhone" required />

                            <span v-if="phoneError" style="color: red;">{{ phoneError }}</span>

                        </div>

                        <div class="form-element-contact">
                            <label :class="{ 'active': isFocused['companyName'] }" for="companyName">Company Name:</label>
                            <input type="text" v-model="companyName" id="companyName" name="companyName"
                                @focus="handleInputFocus('companyName')" @blur="handleInputBlur('companyName')" required />

                        </div>
                        <!-- @focus="handleInputFocus('cemail')" @blur="handleInputBlur('cemail')"  -->
                        <div class="email-id-container">
                            <div class="form-element-contact">
                                <label :class="{ 'active': isFocused['cemail'] }" for="cemail">Professional Email
                                    Address <span style="color: red;">*</span> :</label>
                                <input type="text" v-model="cemail" id="cemail" name="cemail"
                                @focus="handleInputFocus('cemail')" @input="validateCEmail" @blur="handleInputBlur('cemail')"
                                    required />
                                <span v-if="cemailError" style="color: red;">{{ cemailError }}</span>
                            </div>
                            <div class="form-element-contact">
                                <label :class="{ 'active': isFocused['pemail'] }" for="pemail">Personal Email
                                    Address <span style="color: red;">*</span>  :</label>
                                <input type="text" v-model="pemail" id="pemail" name="pemail"
                                    @focus="handleInputFocus('pemail')" @input="validatePEmail" @blur="handleInputBlur('pemail')" required />
                                <span v-if="pemailError" style="color: red;">{{ pemailError }}</span>
                            </div>
                            <div class="email-note">
                                Sometimes corporate firewalls don't let external emails through. We want to make sure we can
                                get in touch and most importantly get an invite to you, so we'll send to both your personal
                                and company email. You can opt out at any time
                            </div>
                        </div>


                        <div class="user-dropdown-container">

                            <select v-model="selectedUsers" id="expectedUsers" :class="userDropdownSelectClass"
                                @focus="handleInputFocus('selectedUsers')" @blur="handleInputBlur('selectedUsers')"
                                required>
                                <option disabled value="" :class="userDropdownOptionClass">Number of People in Contact
                                    Centres</option>
                                <option v-for="option in userOptions" :key="option.value" :value="option.value"
                                    :class="userDropdownOptionClass">
                                    {{ option.label }}
                                </option>
                            </select>

                        </div>

                        <div class="user-dropdown-container">

                            <select v-model="selectedReason" id="selectedReason" :class="userDropdownSelectClass"
                                @focus="handleInputFocus('selectedReason')" @blur="handleInputBlur('selectedReason')" @change="validateReason"
                                required>
                                <option disabled value="" :class="userDropdownOptionClass">Please Select Reason <span style="color: red;">*</span> </option>
                                <option v-for="option in reasonOptions" :key="option.value" :value="option.value"
                                    :class="userDropdownOptionClass">
                                    {{ option.label }}
                                </option>
                            </select>
                            <span v-if="reasonError" style="color: red;">{{ reasonError }}</span>
                        </div>

                        <div class="form-element-contact">
                            <label :class="{ 'active': isFocused['comments'] }" for="comments">Write your comments
                                here:</label>
                            <textarea id="comments" v-model="comments" name="comments" @focus="handleInputFocus('comments')" @blur="handleInputBlur('comments')"
                                @input="validateComments" rows="8" cols="77" style="resize:none"
                                required></textarea>
                            <span v-if="commentsError" style="color: red;">{{ commentsError }}</span>
                        </div>

                        <div class="form-element-contact">
                            <div class="privacyAgree">
                                <input type="checkbox" class="privacyCheckbox" v-model="privacyAgreement" required>
                                <div class="priText">I have read and agreed to the <a class="privacy-policy-link"
                                        href="/privacyPage" target="_blank">Privacy Policy</a>.</div>

                            </div>
                        </div>

                        <div class="form-element-contact" v-if="!recaptchaLoaded">Loading reCAPTCHA...</div>

                        <div v-else class="form-element-contact" >
                            <!-- <div ref="recaptchaContainer" :class="{ 'g-recaptcha': true }" :data-sitekey="siteKey" @submit="onRecaptchaSubmit"
                                data-callback="cbCap"></div> -->
                            <div ref="recaptchaContainer"></div>
                            <!-- <button @click="submitForm">Submit</button> -->
                            <div v-if="!isLoading && !isSuccess"
                                :class="{ 'cta': true, 'greyed': isSubmitDisabledComputed }" @click="submitForm">
                                <svg class="arrow-back" width="18" height="18"></svg>
                                <div class="get-started" :style="{ 'cursor': isSubmitDisabledComputed ? 'no-drop' : 'pointer' }">Submit</div>
                                <svg class="arrow-forward" width="18" height="18" viewBox="0 0 18 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 3L7.9425 4.0575L12.1275 8.25H3V9.75H12.1275L7.9425 13.9425L9 15L15 9L9 3Z"
                                        fill="white" />
                                </svg>
                            </div>
                            <div v-if="isLoading" class="loader"></div>
                            <div v-if="isSuccess" class="success-icon">&#10003; Thank you for contacting us. One of our
                                consultants will get back to you later today or the next working day.
                                We appreciate your interest in Cloudworks and look forward to speaking with you.</div>



                        </div>


                    </div>


                </div>
            </div>

        </div>

    </div>
</template>
<script>

import axios from 'axios';


export default {
    name: 'contactPage',
    props: {
    },
    data() {
        return {
            cookieValue: '',
            privacyAgreement: false,
            isLoading: false,
            isSuccess: false,
            isSubmitDisabled: true,
            isRecaptchaCompleted: false,
            cemailError: '',
            pemailError: '',
            phoneError: '',
            reasonError: '',
            commentsError:'',
            recaptchaLoaded: false,
            siteKey: '6LekfkUpAAAAAFOWjVKbE9Vez-TMTWbewPnEqxJs',
            isFocused: {
                fname: false,
                lname: false,
                pemail: false,
                cemail: false,
                phone: false,
                companyName: false,
                selectedUsers: false,
                comments: false,

            },
            selectedUsers: '',
            userOptions: [
                { value: '1-50', label: '1 - 50' },
                { value: '51-100', label: '51 - 100' },
                { value: '101-200', label: '101 - 200' },
                { value: '201-400', label: '201 - 400' },
                { value: '401-600', label: '401 - 600' },
                { value: '601-1000', label: '601 - 1,000' },
                { value: '1001-2000', label: '1,001 - 2,000' },
                { value: '2001-', label: '> 2,000' },
            ],

            selectedReason:'',
            reasonOptions: [
                {value: 'Price Enquiry',label: 'Price Enquiry'},
                {value: 'Request a demo',label: 'Request a demo'},
                {value: 'More information',label: 'More information'},
                {value: 'Other',label: 'Other'}
            ],

            isFixed: false,
            tipIndex: null,
            tipIndexChild: null,
            activeName: '',
            expandText: 'Expand',
            isExpand: false,
            fname: '',
            lname: '',
            phone: '',
            cemail: '',
            pemail: '',
            companyName: '',
            comments: '',
        }
    },
    components: {

    },
    computed: {
        userDropdownSelectClass() {
            return 'user-dropdown-select';
        },
        userDropdownOptionClass() {
            return 'user-dropdown-option';
        },
        isSubmitDisabledComputed() {
            return this.cemailError || this.pemailError || this.phoneError || !this.isRecaptchaCompleted || !this.cemail || !this.pemail || !this.phone || !this.privacyAgreement || !this.selectedReason || (this.selectedReason === "Other" && !this.comments);
        }
    },
    methods: {
        getCookie(cookieName) {
            const cookies = document.cookie.split(';');

            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();

                if (cookie.startsWith(`${cookieName}=`)) {
                    return cookie.substring(cookieName.length + 1);
                }
            }

            return null;
        },
        validateCEmail() {
            console.log("cemail called")
            // Regular expression for basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (this.cemail === '') {
                this.cemailError = 'Please input valid email';
            } else if (!emailRegex.test(this.cemail)) {
                this.cemailError = 'Please input valid email';
            } else {
                this.cemailError = '';
            }
        },
        validateComments(){
            if(this.selectedReason === "Other"){
                console.log("validateComments called");
                if(this.comments == ""){
                    this.commentsError = "Please provide comments about your enquiry above";
                }
                else{
                    this.commentsError = "";
                }
            }
        },
        validateReason() {
            console.log("reasonValidate called")
            if (this.selectedReason === '') {
                this.reasonError = 'Please input valid reason';
            }
            else if(this.selectedReason === 'Other' && this.comments == ''){
                this.commentsError = 'Please provide comments about your enquiry above'
            }
            else {
                this.reasonError = '';
            }
        },
        validatePEmail() {
            console.log("pemail called")
            // Regular expression for basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (this.pemail === '') {
                this.pemailError = 'Please input valid email';
            } else if (!emailRegex.test(this.pemail)) {
                this.pemailError = 'Please input valid email';
            } else {
                this.pemailError = '';
            }
        },
        scrollEvent() {
            if (window.scrollY > 60.5) {
                this.isFixed = true
            }
            if (window.scrollY < 60.5) {
                this.isFixed = false
            }
        },
        handleInputFocus(field) {
            this.isFocused[field] = true;
        },
        handleInputBlur(field) {

            if (this[field] === '') {
                this.isFocused[field] = false;
            }
            // if (field == 'phone') this.validatePhone();
            // if (field == 'cemail') this.validateCEmail();
            // if (field == 'pemail') this.validatePEmail();
            // if (field == 'selectedReason') this.validateReason();

        },

        validatePhone() {
            const numericRegex = /^(\+\d{1,3}[- ]?)?0?[1-9]\d{9}$/;

            if (this.phone === '') {
                this.phoneError = 'Phone is required';
            } else if (!numericRegex.test(this.phone)) {
                this.phoneError = 'Please Enter Correct Phone';
            } else {
                this.phoneError = '';
            }
        },


        onRecaptchaSubmit(token) {

            // console.log('reCAPTCHA token:', token);
            if (token) this.isRecaptchaCompleted = true;

        },

        submitForm() {
            if (!this.isSubmitDisabledComputed)
                this.formv3();
        },
        formv3() {
            this.isLoading = true;
            const url = "https://api.hsforms.com/submissions/v3/integration/submit/143242721/79eb51ac-d41b-486e-b30c-f5e72bfad3f6";
            var data1 = {
                submittedAt: new Date().getTime().toString(),
                fields: [
                    {
                        "name": "firstname",
                        "value": this.fname
                    },
                    {
                        "name": "lastname",
                        "value": this.lname
                    },
                    {
                        "name": "phone",
                        "value": this.phone
                    },
                    {
                        "name": "company",
                        "value": this.companyName
                    },
                    {
                        "name": "email",
                        "value": this.cemail
                    },
                    {
                        "name": "personal_email_address",
                        "value": this.pemail
                    },
                    {
                        "name": "expected_number_of_users",
                        "value": this.selectedUsers
                    },
                    {
                        "name": "contact_us_comments",
                        "value": this.comments
                    },
                    {
                        "name": "TICKET.subject",
                        "value": "ContactUS-" + this.cemail + "-" + Date()
                    },
                    {
                        "name": "TICKET.content",
                        "value": this.comments
                    }
                ],
                context: {
                    "hubspotutk ": this.hubspotutk,
                }
            };

            axios.post(url, data1, {
                headers: {
                    'Content-Type': 'application/json',


                },
            })
                .then(response => {

                    console.log(response)
                    this.isSuccess = true;
                    this.isLoading = false;
                })
                .catch(error => {

                    console.log(error)
                });
        },
        initializeRecaptcha() {

            if (typeof grecaptcha !== 'undefined') {

                const recaptchaContainer = this.$refs.recaptchaContainer;
                /* global grecaptcha */
                grecaptcha.render(recaptchaContainer, {
                    sitekey: this.siteKey,
                    callback: this.onRecaptchaSubmit,
                });
            } else {

                setTimeout(() => this.initializeRecaptcha(), 200);
            }
        },
    },
    created() {
        document.addEventListener('scroll', this.scrollEvent)
    },
    mounted() {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            this.recaptchaLoaded = true;
            grecaptcha.ready(() => {
                this.initializeRecaptcha();
            });
        };
        document.head.appendChild(script);

        console.log(this.isSubmitDisabledComputed);

        this.cookieValue = this.getCookie('hubspotutk');

        if (this.cookieValue !== null) {
            // console.log(`Value of hubspotutk: ${this.cookieValue}`);
        } else {
            console.log('Cookie not found.');
        }

    },
}
</script>

<style scoped lang="less">
@import '../css/font.css';


.container-main {
    margin: 0 auto;
    background: #F2F3F4;

}


.user-dropdown-label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.user-dropdown-select {
    width: 100%;
    padding: 8px;
    font-size: 16px;
}

.user-dropdown-option {
    font-size: 16px;
}


.center {
    margin: 0 auto;
    width: 80%;
}

.container {
    background: #F2F3F4;
}


// .background-container{
//     // background: url("data:image/svg+xml,%3Csvg class='rectangle-685' width='1440' height='768' viewBox='0 0 1440 768' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_1608_6211)'%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint0_angular_1608_6211)' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint1_radial_1608_6211)' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint2_angular_1608_6211)' fill-opacity='0.2' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint3_linear_1608_6211)' /%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1608_6211' x='-4' y='0' width='1448' height='768' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix' /%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' /%3E%3CfeOffset dy='4' /%3E%3CfeGaussianBlur stdDeviation='2' /%3E%3CfeComposite in2='hardAlpha' operator='out' /%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' /%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1608_6211' /%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1608_6211' result='shape' /%3E%3C/filter%3E%3CradialGradient id='paint0_angular_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(720 584) rotate(-106.978) scale(1076.61 2896.66)'%3E%3Cstop offset='0.0729167' stop-color='%230C5C6A' /%3E%3Cstop offset='0.161458' stop-color='%232AA1B6' /%3E%3Cstop offset='0.442708' stop-color='%23D5DBE0' /%3E%3Cstop offset='0.621087' stop-color='white' /%3E%3Cstop offset='0.755208' stop-color='white' /%3E%3Cstop offset='0.916667' stop-color='%232AA1B6' /%3E%3Cstop offset='0.958333' stop-color='%230C5C6A' /%3E%3C/radialGradient%3E%3CradialGradient id='paint1_radial_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(-3.60641) scale(657.415 697.55)'%3E%3Cstop stop-color='%2352CBE0' /%3E%3Cstop offset='1' stop-color='%232AA1B6' stop-opacity='0.2' /%3E%3C/radialGradient%3E%3CradialGradient id='paint2_angular_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(799.5 652.5) rotate(175.106) scale(830.415 2558.69)'%3E%3Cstop stop-color='%230C5C6A' /%3E%3Cstop offset='0.104167' stop-color='%230C5C6A' /%3E%3Cstop offset='0.65625' stop-color='%232698AC' /%3E%3Cstop offset='0.723958' stop-color='%23289CB0' /%3E%3Cstop offset='0.817708' stop-color='%232AA1B6' /%3E%3Cstop offset='0.916667' stop-color='%232AA1B6' /%3E%3C/radialGradient%3E%3ClinearGradient id='paint3_linear_1608_6211' x1='720' y1='0' x2='720' y2='847' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0979163' stop-color='%230C5C6A' /%3E%3Cstop offset='1' stop-color='%230C5C6A' stop-opacity='0' /%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
//     width: 100%;
//     height: 300px;
//     // aspect-ratio: ;
//     position: absolute;
//     // z-index: 0;

// }

.banner-box {
    overflow: hidden;
    width: 100%;
    background: url('../assets/image/contact-bg.svg');
    background-repeat: no-repeat;
    // background-size: 100% 50%;



    .fixed-box {
        width: 100%;
        z-index: 99;
        background: #0C5C6A;

        &.active {
            position: fixed;
            background-color: rgba(255, 255, 255, 0.8);

            .menu {
                a {
                    color: #000000;

                    &:last-child {
                        background: linear-gradient(0deg, #2AA1B6, #2AA1B6);
                        border: .5px solid #2AA1B6;
                    }
                }
            }

            .header {
                padding-bottom: 16px;
            }
        }
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        padding-bottom: 16px;

        .menu {
            a {
                //styleName: Sec -WEB/Paragraph Regular/Medium;
                font-family: Roboto;
                font-size: 16px;
                font-weight: 500;
                line-height: 44.5px;
                letter-spacing: 0em;
                text-align: center;
                color: #FFFFFFCC;
                text-decoration: none;
                padding: 8px 16px;

                &.active {
                    border-bottom: 2px solid #fff;
                    font-weight: 600;
                }

                &:last-child {
                    margin-right: 0px;
                    border: .5px solid #fff;
                    padding: 8px 24px;
                    border-radius: 4px;
                }
            }
        }
    }

    .title {
        margin-top: 36px;
        color: #FFFFFF;
        display: flex;
        flex-direction: column;
    }

    .price-box {
        background: #0C5C6A;
        border-radius: 16px;
        margin-top: 60px;

        .package {
            padding: 12px 0px;

            img {
                width: 18px;
                height: 18px;
                margin-left: 8px;
            }
        }

        .package-top {
            padding: 12px 20px;
            color: #FFFFFF80;

        }

        div {
            box-sizing: border-box;
        }

        .outer {
            background: #0D4953;
            border-radius: 16px;

            .item-box-standard {
                background: #F8F9F9;
            }

            .item-box-starter-middle {
                padding: 0px 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            .item-box-standard-middle {
                padding: 0px 30px;
                border-right: 8px solid #5298E0;
                border-left: 8px solid #5298E0;
                background: #F2F3F4;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #5298E0;
                font-weight: 600;
            }

            .item-box-enterprise-middle {
                padding: 0px 30px;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            .package-middle {
                padding: 12px 20px;
                color: #fff;

                .position-box {
                    position: relative;
                    display: flex;
                }

                .tip {
                    position: absolute;
                    width: 200px;
                    left: 0px;
                    top: 60px;
                    border-radius: 0px 16px 16px 16px;
                    background: #0D4953;
                    padding: 8px;
                    transition: all .2s linear;
                    opacity: 0;

                    &.active {
                        transition: all .2s linear;
                        left: 30px;
                        top: 30px;
                        opacity: 100%;
                    }
                }
            }
        }

        .colum {
            .item-box-standard-top {
                padding: 0px 30px;
                border-top: 8px solid #5298E0;
                border-right: 8px solid #5298E0;
                border-left: 8px solid #5298E0;
                border-radius: 16px 16px 0px 0px;
                background: #F2F3F4;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .item-box-starter-top {
                padding: 0px 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            .item-box-enterprise-top {
                padding: 0px 30px;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            display: flex;

            >div {
                width: 25%;
            }

            .package {
                display: flex;
                align-items: center;
            }

            .item-box-standard {
                border-left: 8px solid #5298E0;
                border-right: 8px solid #5298E0;
            }
        }

        .priceUser {
            >.colum {
                display: flex;
                flex-direction: column;

                .box {
                    display: flex;
                    width: 100%;

                    >div {
                        width: 25%;
                    }
                }

                .childList {
                    margin-left: 20px;
                    width: calc(100% - 20px);
                    box-sizing: border-box;
                    border-radius: 16px 0px 0px 16px;
                    overflow: hidden;
                    max-height: 0px;
                    transition: all .4s ease 0s;

                    &.active {
                        max-height: 300px;
                    }

                    >.colum {
                        &:nth-child(1) {
                            .border-padding {
                                border-radius: 16px 0px 0px 0px;
                            }
                        }

                        &:last-child {
                            .border-padding {
                                border-radius: 0px 0px 0px 16px;
                            }
                        }

                        >div {
                            background-color: #F2F3F4;
                            width: calc((100% + 20px)/4);

                            &:nth-child(1) {
                                width: calc((100% + 20px)/4 - 20px);
                            }

                            &.border-padding {
                                background: #0D4953;
                            }
                        }

                        &:last-child {
                            .item-box-standard {
                                border-bottom: none;
                                border-radius: 0px;
                            }

                            .item-box-starter {
                                border-radius: 0px;
                                margin-bottom: 0px;

                                .starter {
                                    border-bottom: none;
                                }
                            }

                            .item-box-enterprise {
                                margin-bottom: 0px;
                                border-radius: 0px;
                            }

                            .enterprise,
                            .standard,
                            .starter {
                                border-bottom: none;
                            }
                        }
                    }
                }
            }

            .position-box {
                position: relative;
                display: flex;
            }

            .tip {
                position: absolute;
                width: 200px;
                left: 0px;
                top: 60px;
                border-radius: 0px 16px 16px 16px;
                background: #0D4953;
                padding: 8px;
                transition: all .2s linear;
                opacity: 0;

                &.active {
                    transition: all .2s linear;
                    left: 30px;
                    top: 30px;
                    opacity: 100%;
                }
            }

            .expand {
                margin-left: 34px;
                color: #52CBE0;
                font-family: Roboto;
                font-size: 12px;
                font-weight: 500;
                line-height: 20px;
                letter-spacing: 0em;
                text-align: right;
                text-decoration: underline;
                cursor: pointer;
            }

            .btn {
                margin-bottom: 20px;
                margin-top: 8px;
                padding: 12px 38px;
                text-align: center;
                border-radius: 4px;
                border: 1px solid #BCC5EA;
                cursor: pointer;
            }

            .btn-standard {
                background: #5298E0;
                color: #FFFFFF;
            }

            .starter-check {
                img {
                    border-radius: 50%;
                    background: #E05288;
                }
            }

            .standard-check {
                img {
                    border-radius: 50%;
                    background: #5298E0;
                }
            }

            .enterprise-check {
                img {
                    border-radius: 50%;
                    background: #255A91;
                }
            }

            .border-padding {
                padding: 0 20px;
            }

            .colum {
                .item-box-enterprise {
                    margin-right: 8px;
                }

                .item-box {
                    background: #F8F9F9;
                    padding: 0px 30px;
                }

                background: #0F363C;

                &:nth-child(1) {
                    border-radius: 16px 16px 0px 0px;
                }

                &:last-child {
                    border-radius: 0px 0px 16px 16px;
                }

                .package {
                    border-bottom: 1px solid #4B686D80;
                    color: #fff;
                }

                .starter,
                .standard,
                .enterprise {
                    padding: 12px 0px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-bottom: 1px solid #D5DBE0
                }

                &:last-child {
                    .item-box-standard {
                        border-bottom: 8px solid #5298E0;
                        border-radius: 0px 0px 10px 10px;
                    }

                    .item-box-starter {
                        border-radius: 0px 0px 0px 16px;
                        margin-bottom: 8px;

                        .starter {
                            border-bottom: none;
                        }
                    }

                    .item-box-enterprise {
                        margin-bottom: 8px;
                        border-radius: 0px 0px 16px 0px;
                    }

                    .enterprise,
                    .standard,
                    .starter {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}




// contact

.container-contact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 18px auto;
    margin-bottom: 100px;
}

.left-section-contact {
    flex: 1.2;
    padding: 20px;

    .working {
        height: 825px;
    }
}

.left-section-contact img {
    max-width: 100%;
    height: auto;
}

.gap-contact {
    width: 20px;
    /* Adjust the gap width as needed */
}

.right-section-contact {
    // position: relative;
    flex: 1;
    padding: 10px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    /* Stack child elements vertically */
    align-items: center;
}

.contact-form {
    // border: 1px solid #ccc;
    // padding-left: 150px;
    max-width: 500px;
    width: 100%;
    //  margin: 0 auto;
}

.privacyAgree {
    display: flex;
    // background: rgba(12, 92, 106, 0.9);
    padding: 10px;

    // @media screen and (max-width:900px) {
    //     display: -webkit-box;
    // }


    .privacyCheckbox {
        flex: 1;

    }


    .priText {
        margin-left: 10px;
        // color: var(--cloudworks-neutral-white, #FFF);
        font-family: Roboto;
        flex: 13;
        font-size: 14px;

        // .privacy-policy-link{
        //     color:#2aa1b699
        // }
        a {
            color: #70d2e3;
        }

        a:hover {
            color: #e7fbffff;
        }
    }
}

.fullname {

    display: flex;
    justify-content: space-between;

    .form-element-contact {
        flex: 1;

    }

    .f-name {
        margin: 0 5px 10px 0;
    }

    .l-name {
        margin: 0 0 10px 5px;
    }
}

.loader {
    border: 4px solid #0c5c6a78;
    border-top: 4px solid #0C5C6A;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin-left: 20px;
    animation: spin 1s linear infinite;
    position: relative;
    margin-top: 18px;
    // top: 50%;
    // left: 50%;
    transform: translate(-50%, -50%);
}

.success-icon {
    margin-top: 18px;
    color: #4caf50;
    font-size: 24px;
    position: relative;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

button.loading {
    cursor: not-allowed;
    opacity: 0.7;
}

.email-id-container {
    padding: 16px;
    // display: flex;
    // width: 486px;
    padding: 16px;
    // flex-direction: column;
    // align-items: flex-start;
    // gap: 16px;
    border-radius: 4px;
    background: rgba(16, 41, 45, 0.20);
}

.email-note {
    color: var(--cloudworks-neutral-white, #FFF);

    /* Sec -WEB/Paragraph XSmall/Medium */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
}

.form-element-contact {

    margin-bottom: 10px;
    // padding-left: 5%;
    // padding-right: 5%;
    // margin: 0 auto;
    position: relative;

    input {
        font-family: Hind Vadodara;
        border-radius: 4px;
        border-color: white;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        // margin: 0 auto;

    }

    textarea {
        border-radius: 4px;
        border-color: white;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        height: 150px;
    }

    label {
        position: absolute;
        font-weight: normal !important;
        left: 10px;
        top: 10px;
        transition: transform 0.3s, font-size 0.3s;
    }

    label.active {
        transform: translateY(-10px);
        font-size: 12px;
    }


}



input,
textarea,
select {
    width: 100%;
    padding: 10px;
    font-size: 16px;
}

.user-dropdown-container {
    width: 100%;
    //     padding-left: 5%;
    // padding-right: 5%;
    // padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 10px;
}

.form-element-contact label {
    display: block;
    font-weight: bold;
}

// .form-element-contact input[type="text"] {
//     width: 100%;
//     padding: 5px;
//     margin: 5px 0;
// }

// .form-element input[type="email"],
// .form-element input[type="tel"] {
//     width: 100%;
//     padding: 5px;
//     margin: 5px 0;
// }

// .submit-button-contact {
//     text-align: right;
//     // max-width: 25%;
// }

//recent

.frame-2608797,
.frame-2608797 * {
    box-sizing: border-box;
}

.frame-2608797 {
    display: flex;
    flex-direction: row;
    gap: 50px;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
}

.frame-285232 {
    flex-shrink: 0;
    width: 604px;
    height: 668px;
    position: relative;
    overflow: hidden;
}

.image-63 {
    width: 1002px;
    height: 668px;
    position: absolute;
    left: calc(50% - 501px);
    top: 0px;
}

.frame-2608796 {
    flex-shrink: 0;
    width: 486px;
    height: 668px;
    position: relative;
}

.frame-2608795 {
    width: 486px;
    height: 556px;
    position: absolute;
    left: 0px;
    top: 112px;
}

.outline-cta {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    width: 486px;
    position: absolute;
    left: 0px;
    top: 256px;
}

.expected-user {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--sec-web-paragraph-regular-regular,
            400 16px/24px "Roboto",
            sans-serif);
    opacity: 0.800000011920929;
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.arrow-drop-down {
    flex-shrink: 0;
    position: relative;
    overflow: visible;
}

.outline-cta2 {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    width: 486px;
    position: absolute;
    left: 0px;
    top: 192px;
}

.company-name {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--sec-web-paragraph-regular-regular,
            400 16px/24px "Roboto",
            sans-serif);
    opacity: 0.800000011920929;
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.outline-cta3 {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    width: 486px;
    position: absolute;
    left: 0px;
    top: 128px;
}

.telephone-number {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--menu-text, 400 16px/24px "Hind Vadodara", sans-serif);
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.outline-cta4 {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    width: 486px;
    position: absolute;
    left: 0px;
    top: 64px;
}

.email-address {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--menu-text, 400 16px/24px "Hind Vadodara", sans-serif);
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.outline-cta5 {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    width: 486px;
    position: absolute;
    left: 0px;
    top: 0px;
}

.your-name {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--menu-text, 400 16px/24px "Hind Vadodara", sans-serif);
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.outline-cta6 {
    background: var(--cloudworks-neutral-white, #ffffff);
    border-style: solid;
    border-color: #545d7d;
    border-width: 0px 0px 1px 0px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 486px;
    height: 172px;
    position: absolute;
    left: 0px;
    top: 320px;
}

.write-your-comments-here {
    color: var(--cloudworks-grey-original, #545d7d);
    text-align: left;
    font: var(--sec-web-paragraph-regular-regular,
            400 16px/24px "Roboto",
            sans-serif);
    opacity: 0.800000011920929;
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}


.greyed {
    background: var(--product-color-live-desk-dark, #0c5c6a37) !important;
    cursor:no-drop;
}


.cta {
    margin-top: 18px;
    background: var(--product-color-live-desk-dark, #0c5c6a);
    border-radius: 4px;
    padding: 12px 16px 12px 16px;
    display: flex;
    flex-direction: row;
    // gap: 10px;
    align-items: center;
    // justify-content: center;
    position: relative;
    max-width: 25%;
    // left: 0px;
    // top: 508px;
}

.arrow-back {
    flex-shrink: 0;
    position: relative;
    overflow: visible;
}

.get-started {
    cursor: pointer;
    color: var(--cloudworks-neutral-white, #ffffff);
    text-align: center;
    font: var(--sec-web-paragraph-regular-medium,
            500 16px/24px "Roboto",
            sans-serif);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.arrow-forward {
    flex-shrink: 0;
    position: relative;
    overflow: visible;
}

.a-powerful-tool-you,
.a-powerful-tool-you-mobile {
    color: var(--cloudworks-neutral-white, #ffffff);
    text-align: left;
    font: var(--pri-web-display-large-large,
            600 64px/82px "Work Sans",
            sans-serif);
    // position: absolute;
    // left: 0px;
    // top: 0px;
}

.a-powerful-tool-you-mobile {
    display: none;
}

@media screen and (max-width:900px) {
    .container-contact {
        flex-direction: column;
        margin: 0 auto;
        width: 95%;

        .a-powerful-tool-you-mobile {
            font-size: 28px;
            font-weight: 500;
            line-height: unset;
            margin-bottom: 10px;
        }

        .a-powerful-tool-you {
            display: none;
        }

        .a-powerful-tool-you-mobile {
            display: block;
        }

        .contact-form {
            .fullname {
                flex-direction: column;

                .l-name {
                    margin-left: 0;
                }
            }
        }

        .working {
            // height: unset;
            // width: 100%;
            display: none;
        }

        .cta {
            // margin-top: 20px;
            max-width: max-content;
            gap: 8px;

            .arrow-back {
                display: none;
            }
        }
    }

}
</style>
  